export default __webpack_public_path__ + "static/media/q11_step1.c9fda46a.png";